/*
 * @providesModule SMSVerifyStyle
 */

import SkillzStyle from 'SkillzStyle';
import {Dimensions, Platform, StyleSheet} from 'react-native';
import Sizes from 'Sizes';

const WEBVIEW_TOP = 68;
export const errorColor = '#DD6952';
export const greyColor = '#808080';
export const defaultColor = '#4890E8';

const defaultStyles = StyleSheet.create({
  banner: {
    marginVertical: 16,
  },

  smsMarketingWrapper: {
    marginBottom: 40,
    marginRight: 25,
    marginLeft: 25,
    marginTop: -15,
  },

  newSmsMarketingWrapper: {
    marginBottom: 0,
    marginTop: 0,
    marginLeft: 25,
  },

  bodyContainer: {
    alignSelf: 'center',
    width: Sizes.isTablet() ? 430 : 360,
  },

  button: {
    borderRadius: 100,
    borderColor: defaultColor,
    borderWidth: 1,
  },

  buttonDefault: {
    borderRadius: 100,
    borderColor: greyColor,
    borderWidth: 1,
  },

  callTextStyle: {
    textAlign: 'center',
    fontSize: 16,
    ...SkillzStyle.fullStyles.fontRegular,
    ...(Platform.OS === 'android'
      ? SkillzStyle.fullStyles.fontBold
      : SkillzStyle.fullStyles.fontSemiBold),
    fontStyle: 'normal',
    top: -20,
    marginTop: 20,
  },

  newCallTextStyle: {
    textAlign: 'center',
    ...SkillzStyle.fullStyles.fontBold,
    fontSize: 14,
    ...SkillzStyle.fullStyles.fontRegular,
    fontStyle: 'normal',
    top: -20,
    textDecorationColor: SkillzStyle.fullStyles.cashIconGradient[0],
    textDecorationLine: 'underline',
    marginTop: 40,
  },

  codeInputContainer: {
    height: 63,
    marginBottom: 72,
    marginTop: 16,
  },

  newCodeInputContainer: {
    height: 63,
    marginBottom: 42,
    marginTop: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },

  countryBoxArrowContainer: {
    marginTop: -10,
    alignSelf: 'flex-end',
    right: 9,
    top: -3,
  },

  countryBoxArrow: {
    height: 5,
    width: 10,
  },

  countryBoxContainer: {
    borderColor: '#999999',
    borderRadius: 8,
    borderWidth: 1,
    height: 63,
    width: 92,
    justifyContent: 'center',
  },

  countryBoxFlagContainer: {
    left: 6,
  },

  countryBoxFlag: {
    height: 11,
    width: 16,
    top: 2,
  },

  countryBoxText: {
    marginTop: -16,
    left: 20,
    fontSize: 16,
    color: '#000000',
    fontFamily: 'Open Sans',
  },

  dataFee: {
    ...SkillzStyle.fullStyles.fontNormal,
    fontSize: 12,
    lineHeight: 20,
    fontStyle: 'normal',
    top: 17,
    color: '#000',
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'center',
  },

  disabledSendButton: {
    backgroundColor: 'rgba(255,255,255,0.3)',
    height: 50,
    borderRadius: 100,
    top: -48,
    marginBottom: -48,
  },

  editButton: {
    color: defaultColor,
    fontFamily: 'OpenSans-Bold',
  },

  editButtonHidden: {
    color: 'transparent',
    fontFamily: 'OpenSans-Bold',
  },

  errorInfo: {
    height: 13,
    width: 13,
    top: 5,
  },

  errorMessage: {
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
  },

  errorMessageCode: {
    top: -40,
    left: 2,
    marginTop: -42,
    height: 42,
  },

  errorText: {
    top: -10,
    left: 17,
    fontSize: 12,
    lineHeight: 16,
    fontFamily: 'OpenSans-Bold',
  },

  labelPhoneInput: {
    left: 12,
    fontSize: 12,
    color: defaultColor,
    lineHeight: 16,
    fontFamily: 'OpenSans-Bold',
    top: Platform.OS === 'android' ? 10 : 0,
  },
  messageBody: {
    fontSize: 16,
    lineHeight: 24,
    ...SkillzStyle.fullStyles.fontRegular,
    color: '#000',
  },

  newMessageBody: {
    fontSize: 16,
    lineHeight: 24,
    ...SkillzStyle.fullStyles.fontSemiBold,
    ...SkillzStyle.fullStyles.textColorTertiary,
    textAlign: 'center',
  },

  messageHeader: {
    fontSize: Sizes.isTablet() ? 24 : 20,
    lineHeight: 28,
    fontFamily: 'OpenSans-Bold',
    color: '#000',
  },

  newMessageHeader: {
    fontSize: 28,
    lineHeight: 38,
    ...SkillzStyle.fullStyles.fontBold,
    ...SkillzStyle.fullStyles.textColorSecondary,
    textAlign: 'center',
    marginBottom: 16,
  },

  phoneInUseHeader: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'OpenSans-Bold',
    color: '#000',
    paddingBottom: 16,
  },

  otpContainer: {
    backgroundColor: 'white',
    borderColor: '#999999',
    borderWidth: 1,
    borderRadius: 8,
    width: 45,
    height: 63,
    justifyContent: 'center',
  },

  otpInput: {
    color: 'black',
    fontSize: 20,
    lineHeight: 24,
    fontFamily: 'OpenSans-Bold',
    textAlign: 'center',
    textAlignVertical: 'center',
  },

  otpSelected: {
    borderColor: defaultColor,
    borderWidth: 2,
  },
  otpError: {
    borderWidth: 2,
    borderColor: errorColor,
  },

  otpStyle: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxHeight: 131,
  },

  newOtpStyle: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // paddingHorizontal: 20,
    paddingVertical: 7,
    marginTop: 32,
  },

  phoneInput: {
    borderRadius: 8,
    borderColor: 'rgba(0, 0, 0, 0.4)',
    borderWidth: 1,
    height: 63,
    justifyContent: 'center',
  },

  phoneInputFocus: {
    borderColor: defaultColor,
  },

  phoneInputContainer: {
    flex: 1,
  },

  phoneInputBox: {
    ...Platform.select({
      android: {
        left: 8,
      },
      web: {
        marginLeft: 8,
        outlineStyle: 'none',
      },
      ios: {
        left: 12,
      },
    }),
    fontFamily: 'OpenSans-Bold',
    fontSize: 16,
    maxWidth: 222,
    color: '#000',
  },

  phoneInputBoxStyle: {
    ...SkillzStyle.fullStyles.fontRegular,
    lineHeight: 24,
    bottom: 2,
  },

  phoneInputBoxPrefill: {
    fontFamily: 'OpenSans-Bold',
    lineHeight: 20,
  },

  placeholderTextColor: {
    color: '#757575',
  },

  signInBtn: {
    color: '#4890e8',
  },

  signInText: {
    color: '#000',
    fontFamily: 'Open Sans',
  },

  tosMessage: {
    color: '#000',
    fontSize: 12,
    opacity: 0.6,
    ...SkillzStyle.fullStyles.fontRegular,
    textAlign: 'center',
    marginBottom: 16,
    paddingTop: 16,
    paddingBottom: 16,
  },

  tosView: {
    height: Dimensions.get('window').height - WEBVIEW_TOP,
    width: Dimensions.get('window').width,
    position: 'absolute',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    width: '100%',
    paddingTop: 16,
    paddingBottom: 30,
  },

  // New styles for SMSCodeInput inline styles
  keyboardAvoidingContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  smsDescriptionContainer: {
    width: '100%',
    alignSelf: 'center',
  },

  smsDescriptionText: {
    fontSize: 16,
    fontStyle: 'normal',
    ...SkillzStyle.fullStyles.fontBold,
    textAlign: 'center',
  },

  phoneNumberText: {
    fontSize: 16,
    fontStyle: 'normal',
    ...SkillzStyle.fullStyles.fontBold,
    lineHeight: 20,
    textAlign: 'center',
  },

  editIcon: {
    height: 20,
    width: 20,
    marginLeft: 4,
    marginTop: -2,
  },

  otpContainerNewUI: {
    borderColor: '#DDDAD6', // default fallback, will be overridden dynamically
  },
});

const darkStyles = StyleSheet.create({
  disabledSendButton: {
    ...defaultStyles.disabledSendButton,
    top: -42,
    height: 42,
  },
  signInText: {
    ...defaultStyles.signInText,
    color: '#fff',
  },
  tosMessage: {
    ...defaultStyles.tosMessage,
    color: '#fff',
    paddingTop: 0,
    opacity: 0.8,
  },
  messageBody: {
    ...defaultStyles.messageBody,
    color: '#fff',
  },
  dataFee: {
    ...defaultStyles.dataFee,
    color: '#fff',
  },
  labelPhoneInput: {
    ...defaultStyles.labelPhoneInput,
    color: '#fff',
  },
  phoneInUseHeader: {
    ...defaultStyles.phoneInUseHeader,
    color: '#fff',
    textAlign: 'center',
  },
  messageHeader: {
    ...defaultStyles.messageHeader,
    color: '#fff',
  },
  newMessageHeader: {
    ...defaultStyles.messageHeader,
    ...SkillzStyle.fullStyles.textColorSecondary,
  },
  countryBoxContainer: {
    ...defaultStyles.countryBoxContainer,
    borderColor: '#DDDAD6',
  },
  countryBoxText: {
    ...defaultStyles.countryBoxText,
    color: '#fff',
  },
  phoneInputBox: {
    ...defaultStyles.phoneInputBox,
    color: '#fff',
  },
  phoneInput: {
    ...defaultStyles.phoneInput,
    borderColor: '#DDDAD6',
  },

  phoneInputFocus: {
    ...defaultStyles.phoneInputFocus,
    borderColor: '#fff',
  },

  // Dark variants for SMSCodeInput styles
  smsDescriptionText: {
    ...defaultStyles.smsDescriptionText,
    color: '#fff',
  },

  phoneNumberText: {
    ...defaultStyles.phoneNumberText,
    color: '#fff',
  },
});

const smallSizeInputStyles = StyleSheet.create({
  labelPhoneInput: {
    display: 'none',
  },
  phoneInput: {
    borderRadius: 8,
    borderWidth: 2,
    borderColor: '#DDDAD6',
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  countryBoxFlag: {
    height: 18,
    width: 26,
  },
  countryBoxText: {
    marginLeft: 6,
    ...SkillzStyle.fullStyles.fontExtraBold,
    fontSize: 16,
    color: '#fff',
    fontFamily: 'Open Sans',
  },
  countryBoxFlagContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 6,
  },
  countryBoxContainer: {
    borderRadius: 8,
    borderWidth: 2,
    height: 52,
    paddingRight: 20,
    position: 'relative',
    justifyContent: 'center',
  },
  countryBoxArrowContainer: {
    alignSelf: 'flex-end',
    right: 6,
    position: 'absolute',
  },
  phoneInputBox: {
    maxWidth: 'auto',
    height: 48,
    fontSize: 16,
    fontFamily: 'Open Sans',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    width: '100%',
    paddingVertical: 0,
  },
});

export const getStyles = (colorVariant?: 'dark', useSmallSize?: boolean) => {
  const newSizingStyles = useSmallSize ? smallSizeInputStyles : {};
  switch (colorVariant) {
    case 'dark':
      return {
        ...defaultStyles,
        ...darkStyles,
        ...newSizingStyles,
      };
    default:
      return {...defaultStyles, ...newSizingStyles};
  }
};

export default defaultStyles;
